import React from "react";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { CompanyInfoFields } from "./form/CompanyInfoFields";
import { CompanyDateFields } from "./form/CompanyDateFields";
import type { Company, CompanyFormData } from "@/types/company";

interface CompanyFormProps {
  onSubmit: (data: CompanyFormData) => void;
  initialData?: Company;
  onClear: () => void;
  isEditing: boolean;
}

export const CompanyForm = ({ onSubmit, initialData, onClear, isEditing }: CompanyFormProps) => {
  const form = useForm<CompanyFormData>({
    defaultValues: {
      name: initialData?.name || "",
      email: initialData?.email || "",
      phone: initialData?.phone || "",
      plan: initialData?.plan || "",
      status: initialData?.status || "",
      due_date: initialData?.due_date || new Date().toISOString(),
      recurrence: initialData?.recurrence || "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <CompanyInfoFields form={form} />
          <CompanyDateFields form={form} />
        </div>

        <div className="flex space-x-2">
          <Button type="submit">
            {isEditing ? "Atualizar" : "Salvar"}
          </Button>
          <Button type="button" variant="outline" onClick={onClear}>
            Limpar
          </Button>
        </div>
      </form>
    </Form>
  );
};